export default __webpack_public_path__ + "static/img-crypto-wesearch-5b48acf4f685437d7696e0eaf2e2fc0e.png";